module.exports = __webpack_public_path__ + "static/media/SHSProdIcons_Speakers.84cbe83c.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/homepage/resources/SHSProdIcons_Speakers.svg
// module id = 3429
// module chunks = 0